<script setup>
import { VueFinalModal } from "vue-final-modal";
import { useModalsStore } from "@/stores/showModals";

import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faCartPlus);

const props = defineProps({
  modalType: {
    type: String,
    validator: (value) => ["social", "whatsapp", "shop"].includes(value),
  },
});
const useModal = useModalsStore();
console.log(props.modalType);
const dataSocial = [
  {
    name: "Guatemala",
    user: "@columbia_GT",
    instagram: "https://www.instagram.com/columbia_gt/",
  },
  {
    name: "Costa Rica",
    user: "@columbiacr",
    instagram: "https://www.instagram.com/columbiacr/",
  },
  {
    name: "Panamá",
    user: "@columbia_pty",
    instagram: "https://www.instagram.com/columbia_pty/",
  },
  // {
  //     name: "El Salvador",
  //     user: "@columbia_sv",
  //     instagram: "https://www.instagram.com/columbia_sv/",
  // },

  // {
  //     name: "Nicaragua",
  //     user: "@columbia_ni",
  //     instagram: "https://www.instagram.com/columbia_ni/",
  // },
  // {
  //     name: "Honduras",
  //     user: "@columbia_hn",
  //     instagram: "https://www.instagram.com/columbia_hn/",
  // },
];

const dataWhatsapp = [
  {
    name: "Guatemala",
    whatsapp: [
      {
        number: "50255126359",
        url: "https://wa.me/50255126359",
      },
    ],
  },
  {
    name: "Costa Rica",
    whatsapp: [
      {
        number: "60651818",
        url: "https://wa.me/50660651818",
      },
    ],
  },
  {
    name: "Panamá",
    whatsapp: [
      {
        name: "Multiplaza ",
        number: "69373605",
        url: "https://wa.me/50769373605",
      },
    ],
  },
];

const dataShopNow = [
  /*   {
    name: "Guatemala",
    url: "https://columbiasportswear.gt/",
  }, */
  {
    name: "Costa Rica",
    url: "https://columbiasportswear.cr/",
  },
  {
    name: "Panamá",
    url: "https://columbiasportswear.pa/",
  },
];
</script>

<template>
  <VueFinalModal
    class="social-modal"
    content-class="social-modal-content flex items-center justify-center"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :lock-scroll="true"
  >
    <div class="bg-white container-social">
      <div
        class="flex flex-col justify-center items-center"
        v-if="!useModal.showModalWhatsapp && !useModal.showShopModal"
      >
        <div class="mb-10 font-gerttb">
          <p
            class="text-title lg:text-5xl uppercase text-center font-bold leading-7"
          >
            conéctate y aventúrate con nosotros
          </p>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <template v-for="(item, index) in dataSocial" :key="index">
            <a
              class="btn-social uppercase text-lg font-gerttsm bg-black text-white p-4 border flex item-center justify-center border-black hover:text-black hover:bg-white transition duration-150"
              target="_blank"
              :href="item.instagram"
            >
              <img
                src="@/assets/images/ig-social.svg"
                class="icon-social transition duration-150"
              />
              <span class="font-bold">{{ item.user }}</span>
            </a>
          </template>
        </div>
      </div>

      <div
        class="flex flex-col justify-center items-center"
        v-else-if="useModal.showShopModal"
      >
        <div class="font-gerttb">
          <p
            class="text-title text-2xl lg:text-4xl uppercase text-center font-bold leading-7"
          >
            Realiza tus compras en línea
          </p>

          <div class="grid lg:grid-cols-3 gap-3 lg:mt-3">
            <template v-for="(item, index) in dataShopNow" :key="index">
              <div class="mt-2">
                <div class="container-btn">
                  <a
                    class="btn-social uppercase text-lg font-gerttsm bg-black text-white p-4 border flex item-center justify-center border-black hover:text-black hover:bg-white transition duration-150"
                    target="_blank"
                    :href="item.url"
                  >
                    <span
                      class="font-bold flex justify-center gap-4 items-center"
                    >
                      <font-awesome-icon :icon="['fas', 'cart-plus']" />
                      {{ item.name }}</span
                    >
                  </a>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-center items-center" v-else>
        <div class="font-gerttb">
          <p
            class="text-title text-2xl lg:text-4xl uppercase text-center font-bold leading-7"
          >
            ¿quieres una atención personalizada? <br />contáctate con nosotros
          </p>

          <div class="grid p-4 lg:grid-cols-3 gap-3 lg:mt-3">
            <template v-for="(item, index) in dataWhatsapp" :key="index">
              <div class="mt-2">
                <template
                  v-for="(whatsapp, index2) in item.whatsapp"
                  :key="index2"
                >
                  <div class="container-btn">
                    <a
                      class="btn-social uppercase text-lg font-gerttsm bg-black text-white p-4 border flex item-center justify-center border-black hover:text-black hover:bg-white transition duration-150"
                      target="_blank"
                      :href="whatsapp.url"
                    >
                      <span class="font-bold flex justify-center items-center">
                        <svg
                          class="mb-1 mr-2"
                          xmlns="http://www.w3.org/2000/svg"
                          width="1em"
                          height="1em"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                          />
                        </svg>
                        {{ item.name }}</span
                      >
                    </a>
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>
<style scoped>
.container-social {
  border-radius: 0.8rem;
  text-align: center;
  margin: 0 auto;
}

.icon-social {
  width: 25px;
  height: 25px;
  margin-right: 5px;
  filter: invert(1);
}

.btn-social span {
  margin-bottom: -3px;
}

.btn-social:hover .icon-social {
  filter: initial;
}

.btn-social {
  border-radius: 5px;
}

.btn-social svg {
  width: 20px;
  height: 20px;
}

/* Pantallas grandes */
@media (min-width: 1500px) {
}

/* PC */
@media (min-width: 992px) and (max-width: 1499px) {
}

/* Tablet */
@media (min-width: 768px) and (max-width: 991px) {
  .btn-social {
    padding: 0.8rem 1.5rem 0.8rem 1.5rem;
  }

  .text-title {
    font-size: 35px;
  }

  .btn-social span {
    margin-bottom: -3px;
    font-size: 12px !important;
  }

  .text-goat {
    font-size: 30px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .grid-cols-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .btn-social span {
    margin-bottom: -3px;
    font-size: 13px !important;
  }

  .text-title {
    font-size: 1.4rem;
  }
}
</style>
